module.exports = __webpack_public_path__ + "f4515d3bb0948c42f9d5c4fe5ab1ab9c.png";